import { betterFetch as defaultFetch } from '@e-socna/better-fetch';
import type { BetterFetch } from '@e-socna/better-fetch';

import { pisteRetryStrategy } from './strategies/retry.strategy';
import type { PISTE_RATE_LIMITS } from './constants/rate-limits.constant';

/**
 * Create a configured fetcher for PISTE API with automatic retry handling
 *
 * @param serviceType - Type of PISTE service (default: 2 msg/s, bulk: 20 msg/s)
 * @param fetch - Optional custom fetch implementation (defaults to betterFetch)
 * @returns A configured fetch function with retry strategy
 *
 * @example
 * ```typescript
 * import { createPisteFetcher } from '@e-socna/gis';
 *
 * const pisteFetch = createPisteFetcher('default');
 * const data = await pisteFetch<Ordinance>(url, { method: 'POST', body: '...' });
 * ```
 */
export const createPisteFetcher =
  (
    serviceType: keyof typeof PISTE_RATE_LIMITS = 'default',
    fetch: BetterFetch = defaultFetch,
  ) =>
  <T>(url: string, options?: RequestInit) =>
    fetch<T>(url, options ?? {}, {
      retryStrategy: pisteRetryStrategy(serviceType),
      retries: 5,
    });
